const styles = {
  global: {
    body: {
      bg: 'gray',
      color: 'black',
    },
    // button: {
    //   color: 'white',
    //   bg: 'primary',
    //   _hover: {
    //     bg: 'primaryOpaque',
    //     color: 'primary',
    //   },
    // },
    a: {
      color: 'primary',
      _hover: {
        color: 'primary',
      },
    },
    p: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '19px',
      // letterSpacing: '0.05em',
    },
  },
};

export default styles;
